import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="py-16 text-center">
      <p className="text-[13px] font-semibold text-cobalt">404</p>
      <h1 className="mt-2 text-[26px] font-extrabold tracking-tight">
        없는 화면입니다
      </h1>
      <Link
        to="/"
        className="mt-6 inline-flex rounded-full bg-ink px-6 py-3 text-[14px] font-semibold text-white"
      >
        포털로 돌아가기
      </Link>
    </div>
  );
}
